import React, { lazy, Suspense } from "react";
import { useInView } from "react-intersection-observer";

const BlogComponent = lazy(() => import("../../components/home/blog.component"));

const LazyBlog = ({ newsForCategories }: any) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });


  return (
    <div ref={ref}>
      {inView ? (
        <Suspense fallback={<></>}>
          <BlogComponent newsForCategories={newsForCategories} />
        </Suspense>
      ) : (
        <></>
      )}
    </div>
  );
};

export default LazyBlog;
